import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, data } from "react-router-dom";
import {
  FaArrowLeft,
  FaCarSide,
  FaUser,
  FaWallet,
  FaCheckCircle,
  FaUserCircle,
  FaPlusCircle,
  FaExclamationTriangle,
  FaSpinner,
  FaChevronLeft,
} from "react-icons/fa";
import { GetVehicle } from "../../Services";

const GetDriverByVehicle = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const vehicleId = location.state?.vehicleId; // Access the vehicle ID

  // console.log(vehicleId);

  // const [driver, setDriver] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Fetch driver by vehicle ID
  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        setLoading(true);
        // const response = await axios.get(
        //   `https://binberu.idaprocharity.com/api/v1/admin/get-driver-by-vehicle/${vehicleId}`
        // );

        const response = await GetVehicle.fetchDriverByVehicle(vehicleId);

        console.log("Vehicles: ", response.data.vehicle);
        console.log("Drivers: ", response.data.driver);

        if (response) {
          setData(response);

          // console.log("driv: ", data);
        } else {
          console.log("ERRROR");
          setError("No driver found for this vehicle.");
        }
      } catch (err) {
        console.error("Error fetching driver:", err);
        setError("Failed to load driver information.");
      } finally {
        setLoading(false);
      }
    };

    fetchDriverData();
  }, [vehicleId]); // Dependency array to re-fetch when vehicleId changes

  // Log driver state whenever it changes
  useEffect(() => {
    // console.log("DD",data);
  }, [data]);

  const handleAssign = () => {
    setShowModal(false);
    alert("✅ Vehicle assigned successfully!");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <FaSpinner className="fa-spin me-2 text-primary" size={24} />
        <h5>Loading driver details...</h5>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <FaExclamationTriangle className="text-danger mb-3" size={40} />
        <h5 className="text-danger">{error}</h5>
        <button
          className="btn btn-outline-secondary mt-3"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-2" /> Back
        </button>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="container mt-5 text-center">
        <h5>No driver data available.</h5>
      </div>
    );
  }

  return (
    <div className="container mt-5 mb-5">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-primary d-flex align-items-center gap-2">
          <FaUser /> Driver & Vehicle
        </h2>
        <button
          className="btn btn-outline-secondary d-flex align-items-center"
          onClick={() => navigate(-1)}
        >
          <FaChevronLeft className="mr-1" />
          Back
        </button>
      </div>

      {/* DRIVER CARD */}
      <div className="card shadow-sm mb-4 border-0 hover-shadow">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0 d-flex align-items-center gap-2">
            <FaUserCircle size={22} /> Driver Information
          </h5>
          <span
            className={`badge px-3 py-2 ${
              data.data.driver?.accountStatus === "ACTIVE"
                ? "bg-success"
                : data.data.driver?.accountStatus === "PENDING"
                  ? "bg-warning text-dark"
                  : "bg-danger"
            }`}
          >
            {data.data.driver?.accountStatus}
          </span>
        </div>
        <div className="card-body">
          <div className="row align-items-center mb-3">
            <div className="col-md-2 text-center">
              <img
                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                  data.driver?.name,
                )}&background=007bff&color=fff`}
                alt="Driver"
                className="rounded-circle shadow-sm"
                width="80"
                height="80"
              />
              <div className="mt-2">
                <span
                  className={`badge rounded-pill ${
                    data.data.driver?.status === "ONLINE"
                      ? "bg-success"
                      : "bg-secondary"
                  }`}
                >
                  ● {data.data?.status}
                </span>
              </div>
            </div>
            <div className="col-md-10">
              <div className="row g-3">
                <ReadOnly label="Name" value={data.data.driver?.name} />
                <ReadOnly label="Country" value={data.data.driver?.country} />
                <ReadOnly
                  label="Phone"
                  value={data.data.driver?.phone_number}
                />
                <ReadOnly label="Email" value={data.data.driver?.email} />
                <ReadOnly
                  label="Reg. No"
                  value={data.data.driver?.registration_number}
                />
                <ReadOnly
                  label="License"
                  value={data.data.driver?.driving_license}
                />
                <ReadOnly
                  label="Registration Date"
                  value={new Date(
                    data.data?.registration_date,
                  ).toLocaleDateString()}
                />
                <ReadOnly
                  label="Total Rides"
                  value={data.data.driver?.totalRides}
                />
                <ReadOnly
                  label="Earnings"
                  value={`$${data.data.driver?.totalEarning?.toFixed(2)}`}
                />
                <ReadOnly
                  label="Wallet"
                  value={`$${data.data.driver?.wallet_balance?.toFixed(2)}`}
                />
                <ReadOnly label="Wallet" value={`$${data.data.vehicle?.id}`} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* VEHICLE CARD */}
      {data.vehicle && (
        <div className="accordion shadow-sm" id="vehicleAccordion">
          <div
            className="accordion-item border-0 mb-2 rounded shadow-sm"
            key={data.vehicle.id}
          >
            <h2 className="accordion-header" id={`heading-${data.vehicle.id}`}>
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${data.vehicle.id}`}
                aria-expanded="true"
                aria-controls={`collapse-${data.vehicle.id}`}
              >
                <FaCarSide className="me-2 text-primary" />
                {data.vehicle.model} ({data.vehicle.plate_no})
              </button>
            </h2>
            <div
              id={`collapse-${data.vehicle.id}`}
              className="accordion-collapse collapse show"
              aria-labelledby={`heading-${data.vehicle.id}`}
              data-bs-parent="#vehicleAccordion"
            >
              <div className="accordion-body">
                <div className="row g-3">
                  <ReadOnly label="Model" value={data.vehicle.model} />
                  <ReadOnly label="Plate" value={data.vehicle.plate_no} />
                  <ReadOnly label="Year" value={data.vehicle.year} />
                  <ReadOnly label="KM/L" value={data.vehicle.km_per_litter} />
                  <ReadOnly label="Color" value={data.vehicle.color} />
                  <ReadOnly label="Service" value={data.vehicle.service_type} />
                  <ReadOnly label="Owner" value={data.vehicle.owner_name} />
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Insurance</label>
                    <div className="d-flex align-items-center">
                      {data.vehicle.insurance_status ? (
                        <span className="text-success d-flex align-items-center">
                          <FaCheckCircle className="me-2" /> Active
                        </span>
                      ) : (
                        <span className="text-danger">Inactive</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="text-end mt-3">
                  <button
                    className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                    onClick={() => setShowModal(true)}
                  >
                    <FaPlusCircle /> Assign Vehicle
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER BUTTONS */}
      <div className="text-end mt-4">
        <button
          className="btn btn-outline-primary me-2"
          onClick={() => window.print()}
        >
          Print Report
        </button>
        <button className="btn btn-secondary ml-4" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  <FaPlusCircle className="me-2" />
                  Assign Vehicle
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to assign this vehicle to the driver?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAssign}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ✅ Reusable read-only field
const ReadOnly = ({ label, value }) => (
  <div className="col-md-6">
    <label className="form-label fw-semibold">{label}</label>
    <div className="form-control bg-light">{value || "—"}</div>
  </div>
);

export default GetDriverByVehicle;
